{
  "version": 1,
  "asset_id": "87c26221-b235-428f-99b5-6c19737aa5a3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/87c26221-b235-428f-99b5-6c19737aa5a3/bypass-revision-weight-chart-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/87c26221-b235-428f-99b5-6c19737aa5a3/bypass-revision-weight-chart-1200.webp",
  "original_filename": "bypass-revision-weight-chart-1200.webp",
  "size": 17542,
  "content_type": "image/webp",
  "created_at": "2026-11-01T23:24:21Z"
}
